import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import ServiceHub from "@/components/ServiceHub";
import FounderNote from "@/components/FounderNote";
import ProofOfImpact from "@/components/ProofOfImpact";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import { AuthProvider } from "@/auth/AuthContext";
import AuthCallback from "@/auth/AuthCallback";
import ProtectedRoute from "@/auth/ProtectedRoute";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/AdminLeads";

function Home() {
  return (
    <div data-testid="home-page" className="relative min-h-screen overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <ServiceHub />
        <FounderNote />
        <ProofOfImpact />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Handle Emergent auth callback synchronously (URL fragment) — must run before ProtectedRoute
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin/leads"
        element={
          <ProtectedRoute adminOnly>
            <AdminLeads />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <AdminLeads />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(11,17,32,0.9)",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "white",
            backdropFilter: "blur(16px)",
          },
        }}
      />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
